module.exports = __webpack_public_path__ + "img/graphTheory.c7534b44.svg";